import { observer } from "mobx-react";
import Button from "components/UI/Button/Button";
import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";
import playIcon from "assets/images/main/play.svg";
import AppStore from "AppStore";
import "./ProjectsActiveBlockError.scss";

const statusContent = {
  error: {
    title: "Задание остановлено",
    description:
        "Вы можете добавить его в архив или изменить настройки и перезапустить",
  },
  paused: {
    title: "Задание приостановлено",
    description: "Причина: исполнители не брали проект (проверьте ставку / скрин / ссылку)",
  },
};

const ProjectsActiveBlockError = observer(({ project, type }) => {
  const { title, description } = statusContent[type];
  return (
      <div className="projects-active-row__error-block-wrapper">
        <div className="projects-active-row__error-block">
          <div className="projects-active-row__error-block_container">
            <div className="projects-active-row__error-icon"/>
            <div className="projects-active-row__error-description_container">
              <p className="projects-active-row__error-description">
                {title}
                <br/>
                <span>
                {description}
              </span>
              </p>
              <p></p>
            </div>
          </div>

          {<div className="projects-active-row__error-block-buttons">
            <Button
                title="Отправить в архив"
                className="projects-active-row__error-block-buttons-archive"
                onClick={() => {
                  AppStore.stopProjectWithConfirm(project);
                }}
            />
            {!project.cancelling &&
                <ButtonWithIcon
                    title="Возобновить"
                    className="projects-active-row__error-block-buttons-resume"
                    icon={playIcon}
                    onClick={() => {
                      if (type === "paused") {
                        AppStore.resumeProject(project)
                      }
                      if (type === "error") {
                        AppStore.reloadProject(project);
                      }
                    }}
                />
            }
          </div>}
        </div>
      </div>
  );
});

export default ProjectsActiveBlockError;
